import { FilesList } from "../../components/files";
import { Loader, Accordion, ActionIcon, Group, ThemeIcon, Text, Space, Button, Modal, } from '@mantine/core'

import React, { useEffect, useState } from 'react'
import { IconMoneybag, IconArrowLeft, IconScript } from '@tabler/icons-react';

import { useParams, useNavigate } from 'react-router-dom';
import { CustomerKYC } from '../../routes/customers/customer_kyc';

import FormCardWrapper from '../../components/form_card_wrapper';

import { collectionGroup, collection, doc, orderBy, limit, DocumentReference, DocumentData, onSnapshot, query, where } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import TransactionInfo from './transaction_info';
import TransactionPaymentCard from './transaction_payment_card';
import { transactionPaidByBank } from '../../../../shared/transactionPayments';
import { useFirestore, useFunctions } from '../../helpers/firebaseContext';
import { Customer, KYC, DocType, TransactionRefreshRequest, BaseResult, FirebaseTransaction, InvoicePaymentConfirmation, } from '../../types';
import GeneratePDFModal from '../../components/generate_pdf_modal';
import { getAddressDetailsEnglish } from '../../helpers/addressHelpers';
import { CurrentViewers } from '../../components/current_viewers';

const TransactionDetails = () => {

    const [transactionObj, setTransactionObj] = React.useState(null as any);
    const db = useFirestore();
    const { transactionID } = useParams();
    const navigate = useNavigate();
    const [openAccordions, setOpenAccordions] = useState<string[]>(["transaction"])
    //Used onSnapshot instead of 'useFirestoreDoc' because the kycStateDoc is depending on kycData
    const [kycState, setKycState] = useState<DocumentData | undefined>(undefined);
    const [kycLoading, setKycLoading] = useState<boolean>(false);
    const [kycData, setKycData] = useState<DocumentData | null>(null);
    const [outdatedKyc, setOutdatedKyc] = useState(false);
    const [paymentSlipLinks, setPaymentSlipLinks] = useState<any[]>([]);
    const [uploadSlipOpened, setUploadSlipOpened] = useState(false);
    const [metaTypes, setMetaTypes] = useState<DocType[]>([]);  //this is for CustomerKYC to set the metatypes of files that exist on the KYC.  That way, we can populate the Generate PDF form properly.
    const [customerRef, setCustomerRef] = useState<DocumentReference>();
    const [transactionRef, setTransactionRef] = useState<DocumentReference>();
    const [customerFullData, setCustomerFullData] = useState<Customer | null>(null);
    const [customerLoading, setCustomerLoading] = useState<boolean>(false);
    const [refreshing, setRefreshing] = useState(false);
    const [transactionPaymentConfirmations, setTransactionPaymentConfirmations] = useState<InvoicePaymentConfirmation[]>([]);

    const functions = useFunctions();
    functions.region = "europe-west1";
    const transactionRefresh = httpsCallable<TransactionRefreshRequest, BaseResult>(functions, 'transactionRefresh');
    const [generatePDFOpen, setGeneratePDFOpen] = useState(false);
    const customPath = `transactions/${transactionObj?.id}/documents`;
    const customFileName = `${kycData?.civilID}-${(kycData as KYC)?.name_en}-${transactionObj?.id}`;
    useEffect(() => {
        const transactionQuery = query(query(collectionGroup(db, "transactions")), where('id', '==', transactionID))
        return onSnapshot(transactionQuery, (snapshot) => {
            if (snapshot.metadata.fromCache) {
                console.log("Cached data", snapshot.docs.length);
                // return;
            } else {
                console.log("Server data", snapshot.docs.length);
            }

            // console.log("Setting transaction obj");
            if (!snapshot.empty) {
                console.log("GETIING TRANSACTION", snapshot?.docs[0]?.data());
                setTransactionRef(snapshot?.docs[0].ref as DocumentReference);
                setTransactionObj(
                    {
                        ...snapshot?.docs[0]?.data() as FirebaseTransaction,
                        transactionTimestamp: snapshot?.docs[0]?.data().transactionTimestamp

                        , transactionRef: snapshot?.docs[0].ref
                    }
                )
            }

        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [transactionID])


    //get customerRef from transaction
    useEffect(() => {
        if (!transactionObj) return;

        let kycUnsubscriber = () => { };

        if (transactionObj?.customerID) {
            setCustomerRef(doc(db, 'customers', transactionObj?.customerID))
        }

        if (transactionObj?.kyc_id) {
            const customerID = transactionObj?.customerID;
            const kycStateDoc = doc(db, `customers/${customerID}/kyc`, transactionObj?.kyc_id);
            setKycLoading(true);

            kycUnsubscriber = onSnapshot(kycStateDoc, (snapshot) => {
                if (snapshot.metadata.fromCache) {
                    console.log("kycState Cached data", snapshot.data());
                } else {
                    console.log("kycState Server data", snapshot.data());
                }

                const rawData = snapshot.data();
                if (!rawData) return;

                // Create a clean data object without circular references
                const data = {
                    ...rawData,
                    id: snapshot.id
                } as KYC;

                setKycData(data);
                setKycState(data.state);
                setKycLoading(false);
            });

        }
        else if (transactionObj?.customerID) {
            // Only proceed if we have a customerID
            const customerDocRef = doc(db, 'customers', transactionObj.customerID);
            const kycCollection = collection(customerDocRef, "kyc");
            let kycQuery = query(kycCollection, orderBy("created", "desc"), limit(1));

            kycUnsubscriber = onSnapshot(kycQuery,
                (snapshot) => {
                    if (snapshot.metadata.fromCache) {
                        console.log("Cached data kycUnsubscriber", snapshot.docs.length);
                    }
                    else {
                        console.log("Server data kycUnsubscriber", snapshot.docs.length);
                    }

                    if (!snapshot.empty) {
                        const rawData = snapshot.docs[0].data();
                        if (rawData) {
                            // Create clean data object without references
                            const data = {
                                ...rawData,
                                id: snapshot.docs[0].id
                            };
                            setKycData(data);
                            setKycState(rawData.state);
                        }
                    }

                },
                (error) => {
                    console.log(error);
                })

        }

        // Return cleanup function
        return () => {
            kycUnsubscriber();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [transactionObj?.customerID, transactionObj?.kyc_id, db]); // More specific dependencies

    // Handle customer data loading
    useEffect(() => {
        if (!customerRef) {
            setCustomerFullData(null);
            setCustomerLoading(false);
            return;
        }

        setCustomerLoading(true);
        const unsubscribe = onSnapshot(customerRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = { ...snapshot.data(), id: snapshot.id } as Customer;
                setCustomerFullData(data);
            } else {
                setCustomerFullData(null);
            }
            setCustomerLoading(false);
        }, (error) => {
            console.error("Error loading customer data:", error);
            setCustomerLoading(false);
        });

        return () => unsubscribe();
    }, [customerRef]);

    /// This effect checks if the transactionObj and kycData are loaded, and compares their creation dates to determine if the KYC is outdated.
    useEffect(() => {
        if (!kycData || !kycData.created || !transactionObj || !transactionObj.created) {
            return;
        }

        let kycDate = kycData.created.toDate();
        kycDate.setHours(0, 0, 0, 0);

        let orderDate = transactionObj.created.toDate();
        orderDate.setHours(0, 0, 0, 0);

        if (kycDate < orderDate) {
            setOpenAccordions(["transaction"]);
            setOutdatedKyc(true);
        } else {
            setOpenAccordions(["kyc", "transaction"]);
            setOutdatedKyc(false);
        }
    }, [kycData, transactionObj]);


    // Debug effect to track state changes
    useEffect(() => {
        console.log('State Debug:', {
            transactionObj: !!transactionObj,
            customerRef: !!customerRef,
            customerFullData: !!customerFullData,
            kycData: !!kycData,
            kycState: !!kycState,
            customerLoading,
            kycLoading
        });
    }, [transactionObj, customerRef, customerFullData, kycData, kycState, customerLoading, kycLoading]);
    useEffect(() => {
        if (!transactionObj) return;

        // handle multiple vs single payment confirmations
        let paymentConfirmations = [] as InvoicePaymentConfirmation[];
        if (transactionObj?.payment_confirmations && transactionObj?.payment_confirmations?.length > 0) {
            paymentConfirmations = transactionObj.payment_confirmations;
        } else if (transactionObj?.payment_confirmation) {
            paymentConfirmations = [transactionObj.payment_confirmation];
        }
        if (paymentConfirmations.length > 0) {
            paymentConfirmations = paymentConfirmations.map((paymentConfirmation) => {
                return {
                    ...paymentConfirmation,
                    name: undefined,
                    currency: undefined,
                    amountInBaseCurrency: undefined,
                    transferAmountWhenReceived: undefined,
                    transactionTitle: paymentConfirmation.name,
                    transferAmount: paymentConfirmation.amountInBaseCurrency,
                    transferCurrency: paymentConfirmation?.currency,
                    fundName: undefined,
                    clientName: transactionObj.customerObj?.name_en,
                    transactionTimestamp: undefined,
                    receivedAt: undefined,
                    transactionDate: paymentConfirmation.transactionTimestamp?.toDate().toLocaleString("en-gb") ?? paymentConfirmation.transactionDate,
                }
            })
        }

        setTransactionPaymentConfirmations(paymentConfirmations);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [transactionObj]);

    return (
        <>
            <Group>
                <ActionIcon onClick={() => {
                    //go back
                    navigate("/transactions");
                }}>
                    <IconArrowLeft size="3rem" />
                </ActionIcon>

                <Button color="green" loading={refreshing} type="button" onClick={
                    async () => {
                        setRefreshing(true);
                        await transactionRefresh({ transactionsID: transactionObj?.id! });
                        setRefreshing(false);
                        console.warn("Transaction refreshed!");
                    }
                }>
                    Refresh Transaction
                </Button>
                <Button
                    disabled={!transactionObj?.signature}
                    onClick={() => { setGeneratePDFOpen(true) }}
                >
                    Generate PDF
                </Button>
                {transactionObj?.paymentSlipRequired && <>
                    {!transactionPaidByBank(transactionObj) && <Button
                        onClick={() => setUploadSlipOpened(true)}
                        disabled={['rejected', 'done'].includes(transactionObj.tags?.transactionStatus?.code)}
                    >Upload Slip</Button>}
                    <Modal opened={uploadSlipOpened} onClose={() => setUploadSlipOpened(false)} title="Upload Slip" size="lg">
                        <Text size="sm" mb="md">Upload the payment slip and mark it as Payment Slip.</Text>
                        <FilesList
                            path={`transactions/${transactionObj.id}/payment_slips/`}
                            links={paymentSlipLinks}
                            setLinks={setPaymentSlipLinks}
                            onChange={() => { transactionRefresh({ transactionsID: transactionObj.id! }); }}
                        />
                    </Modal>
                </>}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div></div>
                    <CurrentViewers type="transactions" id={transactionID ?? ''} size="md" />
                </div>
                {transactionObj &&
                    <GeneratePDFModal
                        generatingForCollection='transaction'
                        transactionContractRef={transactionRef}
                        getCustomerDataKey={"customerObj"}
                        completedKYCData={kycData?.completedKYCData ? {
                            ...kycData.completedKYCData,
                            kyc_id: kycData.id
                        } : undefined}
                        customPath={customPath}
                        customFileName={customFileName}
                        objID={transactionObj?.id}
                        rows={[{


                            ...transactionObj,
                            ...kycData,
                            paciData: transactionObj?.paciData,
                            customerID: customerFullData?.id,
                            id: transactionObj.id,
                            iban: transactionObj.iban,
                            address: {
                                ...kycData?.address, "DetailsEnglish":
                                    kycData?.address ? getAddressDetailsEnglish(kycData?.address)
                                        : "",
                            },

                        }]}
                        paymentConfirmations={transactionPaymentConfirmations}
                        documentsToFetch={
                            [{
                                name: "transactions",
                                subCollectionAccessorName: "id",
                                documentsToAddFunction: () => {

                                    if (transactionObj?.transactionType === "cash_out") {
                                        if (transactionObj?.is_all_available_cash) {
                                            return [{
                                                doNotFlatten: false,
                                                title: "Cash out",
                                                path: "https://storage.googleapis.com/public-pdfs/customer%20portfolio%20cash%20out%20form%20fillable_final.pdf"
                                            }];
                                        } else {
                                            return [{
                                                doNotFlatten: false,
                                                title: "Cash out",
                                                path: "https://storage.googleapis.com/public-pdfs/partial_cash_out_fillable.pdf"
                                            }];
                                        }
                                    }
                                    return [];


                                },
                                type: "collectionGroup"

                            }]
                        }

                        metaTypes={metaTypes}

                        manual={kycData?.completedKYCData ? false : transactionObj.manual}
                        //set the kyc id to be used in case of manual as in that case we dont use latest valid kyc
                        kycID={kycData?.id}
                        opened={generatePDFOpen}
                        setOpened={setGeneratePDFOpen}



                    />}
            </Group>
            <Space h="xl" />
            <Accordion multiple variant='contained' transitionDuration={1000}
                value={openAccordions}
                onChange={setOpenAccordions}>

                <Accordion.Item key="kyc" value="kyc" >
                    <Accordion.Control disabled={!(kycState)} >
                        <Group p="apart">
                            <ThemeIcon
                                variant="gradient"
                                size="xl"
                                aria-label="Gradient action icon"
                                gradient={{ from: 'red', to: 'grape', deg: 180 }}
                            >
                                <IconScript size={30} />
                            </ThemeIcon>
                            <Text
                                component="span"
                                ta="center"
                                variant="gradient"
                                gradient={{ from: 'red', to: 'grape', deg: 180 }}
                                size="xl"
                                fw={700}
                            // style={{ fontFamily: 'Greycliff CF, sans-serif' }}
                            >
                                KYC Information ({
                                    // kycCompleted ? kycTags?.title : 
                                    kycState?.status ||
                                    "No KYC"})
                            </Text>
                            <Text component='span'
                                c="red"
                                fw={700}

                            >
                                {transactionObj?.skipKYC ? "KYC Skipped" : outdatedKyc ? "--Too old--" : ""}
                            </Text>
                        </Group>

                    </Accordion.Control>
                    <Accordion.Panel>
                        {/* below is the old disableUpload condition */}
                        {/* kycState?.status_code === "rejected" || orderStatusCode === "rejected" */}
                        {customerFullData ? (
                            <CustomerKYC
                                kycID={kycData?.id}
                                metaTypes={metaTypes}
                                setMetaTypes={setMetaTypes}
                                customerData={customerFullData}
                                showButton={true}
                                showActiveLinks={true}
                                showKycVersion={false}
                                showGeneratePDF={false}
                            />
                        ) : (
                            <FormCardWrapper>
                                <Loader />
                            </FormCardWrapper>
                        )}
                    </Accordion.Panel>
                </Accordion.Item>

                <Accordion.Item key="transaction" value="transaction">
                    <Accordion.Control >
                        <Group p="apart">
                            <ThemeIcon
                                variant="gradient"
                                size="xl"
                                aria-label="Gradient action icon"
                                gradient={{ from: 'red', to: 'grape', deg: 180 }}
                            >
                                <IconMoneybag size={30} />
                            </ThemeIcon>
                            <Text
                                component="span"
                                ta="center"
                                variant="gradient"
                                gradient={{ from: 'red', to: 'grape', deg: 180 }}
                                size="xl"
                                fw={700}
                                style={{ fontFamily: 'Greycliff CF, sans-serif' }}
                            >
                                Transaction Details
                            </Text>
                        </Group>
                    </Accordion.Control>
                    <Accordion.Panel>
                        {transactionObj && transactionRef ? <TransactionInfo
                            transactionObj={transactionObj}
                            customerRef={customerRef}
                            transactionRef={transactionRef}
                            customerFullData={customerFullData}
                            kycData={kycData}
                            kycState={kycState}
                        /> :
                            <FormCardWrapper >
                                <Loader />
                            </FormCardWrapper>
                        }


                    </Accordion.Panel>
                    { /* Old Transaction Form Code
                    <Accordion.Panel>
                        {transactionObj ?  <TransactionForm
                            transactionObj={transactionObj}
                            disabled={true}
                            hideTitleAndBack={true}
                            title={"Transaction Details"}
                        /> :
                            <FormCardWrapper >
                                <Loader />
                            </FormCardWrapper>
                        }

                    </Accordion.Panel> */}
                </Accordion.Item>
            </Accordion >
        </ >



    )
}

export default TransactionDetails